import { render, staticRenderFns } from "./EditarInstitucionExterna.vue?vue&type=template&id=05340e3c"
import script from "./EditarInstitucionExterna.vue?vue&type=script&lang=js"
export * from "./EditarInstitucionExterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports